export enum TypeOfIncome {
    Employed = 'Employed',
    Pensioner = 'Pensioner',
    EmployedInOwnCompany = 'EmployedInOwnCompany',
    Unemployed = 'Unemployed',
    SelfEmployed = 'SelfEmployed',
    PaidPerHour = 'PaidPerHour'
}
